import "./globals.css";
import "antd/dist/reset.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import {
  SignInPage,
  ForgotPasswordPage,
  AutoLoginPage,
  POSPage,
  EmployeesPage,
  UsersPage,
  LoginSuccessPage,
  ProductsPage,
  PurchasesPage,
  SellingHistory,
  ReturnsHistory,
  ExpensesPage,
  CustomerLedgerPage,
  SupplierLedgerPage,
  ChequesPage,
  SalesReports,
  InventoryReports,
  SalesLedgerReport,
  ItemProfitReport,
  CashFlowReport,
  ChequesReport,
  DiscountsReport,
  NonCashPaymentsReport,
  EmployeePerformanceReport,
  SignOffListReport,
  SignOffDetailReport,
  ProductStockReport,
  ExpiringItemsReport,
  PurchasesReport,
  PurchasedProductsReport,
  ReturnedItemsReport,
  SoldItemsReport,
  RawMaterialsPage,
  RawPurchasesPage,
  RecipesPage,
  ProductionPage,
  StockTransferPage,
  CustomersPage,
  SuppliersPage,
  QuotationsPage,
  StockAdjustmentPage,
  StoreLiveTracking,
  RepairJobsPage,
  AttendanceRegisterPage,
  MonthlyAttendanceSheet,
  PayrollManagementPage,
  LeaveCalendar,
  StoresPage,
  BarcodeEditor,
  BankAccountsPage,
  WhatsAppChatbotPage,
  OnlineOrdersPage,
  AccessPoliciesPage,
  WebInfoManagement,
  TenantsPage,
  TenantDetailPage,
} from "./Page";

import { SidebarProvider } from "./components/ui/sidebar";
import { AppSidebar } from "./components/side-bar/AppSidebar";
import { ProtectedRoute } from "./Hook";
import { REPORT, ROUTE } from "./Constant";
import { KeyboardHandlerNavToPos } from "./components";

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground transition-colors">
      <Router>
        <KeyboardHandlerNavToPos />

        <Routes>
          <Route
            path={"/*"}
            element={
              <>
                <Routes>
                  <Route path={ROUTE.login} element={<SignInPage />} />
                  <Route
                    path={ROUTE.forgotPassword}
                    element={<ForgotPasswordPage />}
                  />
                  <Route
                    path={ROUTE.loginSuccess}
                    element={<LoginSuccessPage />}
                  />
                  <Route
                    path="/auto-login"
                    element={<AutoLoginPage />}
                  />
                </Routes>
              </>
            }
          />

          <Route
            path={"/system/*"}
            element={
              <ProtectedRoute>
                <SidebarProvider>
                  <AppSidebar />
                  <main className="flex-1 w-full bg-background text-foreground overflow-y-auto transition-colors">
                    <Routes>
                      <Route
                        path={ROUTE.sales_billing}
                        element={
                          <ProtectedRoute feature="sales_billing">
                            <POSPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.employee_manage}
                        element={
                          <ProtectedRoute feature="employee_manage">
                            <EmployeesPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.attendance_manage}
                        element={
                          <ProtectedRoute feature="attendance_manage">
                            <AttendanceRegisterPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.monthly_attendance_sheet}
                        element={
                          <ProtectedRoute feature="monthly_attendance_sheet">
                            <MonthlyAttendanceSheet />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.payroll_manage}
                        element={
                          <ProtectedRoute feature="payroll_manage">
                            <PayrollManagementPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.leave_manage}
                        element={
                          <ProtectedRoute feature="leave_manage">
                            <LeaveCalendar />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.user_manage}
                        element={
                          <ProtectedRoute feature="user_manage">
                            <UsersPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.access_policies}
                        element={
                          <ProtectedRoute feature="access_policies">
                            <AccessPoliciesPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.store_manage}
                        element={
                          <ProtectedRoute feature="store_manage">
                            <StoresPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.bank_manage}
                        element={
                          <ProtectedRoute feature="bank_manage">
                            <BankAccountsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.whatsapp_chatbot}
                        element={
                          <ProtectedRoute feature="whatsapp-chatbot">
                            <WhatsAppChatbotPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.online_orders}
                        element={
                          <ProtectedRoute feature="online-orders">
                            <OnlineOrdersPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.product_manage}
                        element={
                          <ProtectedRoute feature="product_manage">
                            <ProductsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.barcode_editor}
                        element={
                          <ProtectedRoute feature="barcode_editor">
                            <BarcodeEditor />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.purchase_manage}
                        element={
                          <ProtectedRoute feature="purchase_manage">
                            <PurchasesPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.raw_material_manage}
                        element={
                          <ProtectedRoute feature="raw_material_manage">
                            <RawMaterialsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.raw_material_purchase}
                        element={
                          <ProtectedRoute feature="raw_material_purchase">
                            <RawPurchasesPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.recipe_manage}
                        element={
                          <ProtectedRoute feature="recipe_manage">
                            <RecipesPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.production_manage}
                        element={
                          <ProtectedRoute feature="production_manage">
                            <ProductionPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.stock_transfer}
                        element={
                          <ProtectedRoute feature="stock_transfer">
                            <StockTransferPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.stock_adjustment}
                        element={
                          <ProtectedRoute feature="stock_adjustment">
                            <StockAdjustmentPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={`${ROUTE.store_live_tracking}/:storeId`}
                        element={
                          <ProtectedRoute feature="store_live_tracking">
                            <StoreLiveTracking />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.repair_jobs}
                        element={
                          <ProtectedRoute feature="repair_jobs">
                            <RepairJobsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.sales_history}
                        element={
                          <ProtectedRoute feature="sales_history">
                            <SellingHistory />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.sales_return}
                        element={
                          <ProtectedRoute feature="sales_return">
                            <ReturnsHistory />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.sales_expenses}
                        element={
                          <ProtectedRoute feature="sales_expenses">
                            <ExpensesPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.customer_credits}
                        element={
                          <ProtectedRoute feature="customer_credits">
                            <CustomerLedgerPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.customer_ledger}
                        element={
                          <ProtectedRoute feature="customer_credits">
                            <CustomerLedgerPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.supplier_ledger}
                        element={
                          <ProtectedRoute feature="customer_credits">
                            <SupplierLedgerPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.customer_manage}
                        element={
                          <ProtectedRoute feature="customer_manage">
                            <CustomersPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.supplier_manage}
                        element={
                          <ProtectedRoute feature="supplier_manage">
                            <SuppliersPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.sales_cheques}
                        element={
                          <ProtectedRoute feature="sales_cheques">
                            <ChequesPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.sales_quotation}
                        element={
                          <ProtectedRoute feature="sales_quotation">
                            <QuotationsPage />
                          </ProtectedRoute>
                        }
                      />

                      {/* Report */}
                      <Route
                        path={ROUTE.report_sales}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <SalesReports />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.report_inventory}
                        element={
                          <ProtectedRoute feature="report_inventory">
                            <InventoryReports />
                          </ProtectedRoute>
                        }
                      />

                      {/* Sales Report */}
                      <Route
                        path={REPORT.sales_ledger}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <SalesLedgerReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.item_profit}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <ItemProfitReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.cash_flow}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <CashFlowReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.cheques}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <ChequesReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.discounts}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <DiscountsReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.non_cash_payments}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <NonCashPaymentsReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.employee_performance}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <EmployeePerformanceReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.sign_off_list}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <SignOffListReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.sign_off_detail}
                        element={
                          <ProtectedRoute feature="report_sales">
                            <SignOffDetailReport />
                          </ProtectedRoute>
                        }
                      />

                      {/* Inventory Report */}
                      <Route
                        path={REPORT.product_stock}
                        element={
                          <ProtectedRoute feature="report_inventory">
                            <ProductStockReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.expiring_items}
                        element={
                          <ProtectedRoute feature="report_inventory">
                            <ExpiringItemsReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.purchases}
                        element={
                          <ProtectedRoute feature="report_inventory">
                            <PurchasesReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.purchased_products}
                        element={
                          <ProtectedRoute feature="report_inventory">
                            <PurchasedProductsReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.returned_items}
                        element={
                          <ProtectedRoute feature="report_inventory">
                            <ReturnedItemsReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={REPORT.sold_items}
                        element={
                          <ProtectedRoute feature="report_inventory">
                            <SoldItemsReport />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path={ROUTE.web_info}
                        element={
                          <ProtectedRoute feature="web_info">
                            <WebInfoManagement />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </main>
                </SidebarProvider>
              </ProtectedRoute>
            }
          />

          <Route
            path={"/system-admin/*"}
            element={
              <ProtectedRoute>
                <div className="min-h-screen bg-gray-50">
                  <Routes>
                    <Route
                      path={ROUTE.system_admin_tenants}
                      element={<TenantsPage />}
                    />
                    <Route
                      path={`${ROUTE.system_admin_tenants}/:id`}
                      element={<TenantDetailPage />}
                    />
                  </Routes>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
